import Writer from "../../components/writer/Writer"

export default function Opening(props){
    return (
        <div className='opening'>
         <Writer />
         
        </div>
      );
}